import { FormControl, FormGroup, Validators } from '@angular/forms';

export class ProposalRequestLineItemForm extends FormGroup<{
  id: FormControl<number | undefined>;
  ProposalRequestId: FormControl<number | undefined>;
  text: FormControl<string>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ProposalRequestId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      text: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }
}
